import type { MapConfig } from '@/components/map/map.types';
import { constant } from '@/constant';

/**
 * The cap the API holds a participant's markers to on a map (formsServices.getMapMaxVotes): the editor's value when it
 * is a positive integer, the default otherwise.
 */
export function getMapMaxMarkers(mapConfig?: Pick<MapConfig, 'maxVotes'> | null): number {
  const maxVotes = Number(mapConfig?.maxVotes);
  return Number.isInteger(maxVotes) && maxVotes >= 1 ? maxVotes : constant.Form.Map.DefaultMaxVotes;
}
